// extracted by mini-css-extract-plugin
export default {"winner-container":"WinnersPage_winner-container__Ji8V0"};